import Spinner from "react-bootstrap/Spinner";
import { PrimaryButton } from "../primary-button/primary-button";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import styles from "./relaunch-container.less";

type RelaunchContainerProps = {
    isCapturing: boolean;
    isProcessing: boolean;
    onClickRelaunch: () => void
};

export const RelaunchContainer = (props: RelaunchContainerProps) => {
    const { isCapturing, isProcessing, onClickRelaunch } = props;

    const content = useSelector(getLanguageContent);

    const capturingText = content.acuant.camera.capturingText;
    const processingText = content.acuant.camera.processingText;
    const relaunchCaptureLabelText = content.acuant.relaunchCaptureLabelText;
    const relaunchCaptureButtonText = content.acuant.relaunchCaptureButtonText;

    return (
        <div className={styles.relaunchContainer}>
            {isCapturing && (
                <p className={styles.capturingText}>{capturingText}</p>
            )}
            {isProcessing && (
                <p className={styles.processingText}>{processingText}</p>
            )}
            <Spinner className={styles.spinner} animation={"grow"} />
            <p className={styles.relaunchText}>{relaunchCaptureLabelText}</p>
            <PrimaryButton
                id={"async-continue"}
                automationId={"async-continue"}
                hideSpinner={true}
                disabled={false}
                type={"button"}
                onClick={onClickRelaunch}
                label={relaunchCaptureButtonText}
            />
        </div>
    );
};